export enum ReweighLogDateFormats {
  MOMENT = 'MM/DD/YYYY HH:mm:ss',
  ANGULAR_PIPE = 'MM/DD/yyyy HH:mm:ss',
}
